/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown> }} Membership_Friend_Guest_AvailableInputs */

const fr_membership_friend_guest_available = /** @type {(inputs: Membership_Friend_Guest_AvailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre abonnement vous permet de venir avec ${i?.limit} ami(s) par mois. Déclarez-le ici avant sa venue pour que l'accueil le laisse entrer. L'invité ne consomme pas vos crédits de cours.`)
};

/**

* @param {Membership_Friend_Guest_AvailableInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_available = /** @type {((inputs: Membership_Friend_Guest_AvailableInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_AvailableInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_available(inputs)
});